// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form__error {
  color: #ff0000;
  font-size: 0.875rem;
  text-align: center;
  width: 100%;
  display: block;
}

.login-form__success {
  color: #22c55e;
  font-size: 0.875rem;
  text-align: center;
  width: 100%;
  display: block;
}

.login-form__inputs__button {
  transition: none !important;
}
.login-form__inputs__button .p-button-label,
.login-form__inputs__button .p-button-icon {
  transition: none !important;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: fixed;
  z-index: 101;
}

.login-form .confirmation-popup {
  visibility: hidden;
  position: fixed;
  display: flex;
  width: auto;
  min-width: 30rem;
  max-width: 35rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex-direction: column;
  background-color: white;
  z-index: 1;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
  padding: 1rem;
  gap: 1rem;
}
.login-form .confirmation-popup.visible {
  visibility: visible !important;
  opacity: 1;
  transition: visibility 0s, opacity 0.5s linear;
}
.login-form .confirmation-popup__header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #DEDEDE;
  padding-bottom: 15px;
  position: relative;
}
.login-form .confirmation-popup__header__titles {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0.4rem;
  width: 100%;
  padding: 0 40px;
}
.login-form .confirmation-popup__header__titles__title {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  color: black;
  white-space: nowrap;
  overflow: visible;
}
.login-form .confirmation-popup__header__close-button {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;
  background-color: white;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.login-form .confirmation-popup__content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.login-form .confirmation-popup__content__warning {
  display: flex;
  justify-content: center;
  font-size: 0.85rem;
  color: #7E7E7E;
  white-space: nowrap;
  overflow: visible;
  text-wrap: wrap;
  text-align: center;
}
.login-form .confirmation-popup__content__title {
  font-size: 0.9rem;
  color: black;
  font-weight: bold;
  white-space: nowrap;
  overflow: visible;
}
.login-form .confirmation-popup__footer {
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 0.5rem;
}
.login-form .confirmation-popup__footer__confirm-button.p-button {
  width: fit-content;
  height: 40px;
  background-color: black !important;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.login-form .confirmation-popup__footer__confirm-button.p-button:hover {
  background-color: #333 !important;
}
.login-form .confirmation-popup__footer__cancel-button.p-button {
  width: fit-content;
  height: 40px;
  background-color: #F5F6FA;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.login-form .confirmation-popup__footer__cancel-button.p-button:hover {
  background-color: #EAEBEF;
}`, "",{"version":3,"sources":["webpack://./src/features/authentication/components/sign-in-form/sign-in-form.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;AACI;;EAEI,2BAAA;AACR;;AAGA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAAJ;AAEI;EACI,8BAAA;EACA,UAAA;EACA,8CAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;AADR;AAGQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AADZ;AAGY;EACI,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AADhB;AAKQ;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAHZ;AAOI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AALR;AAOQ;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AALZ;AAQQ;EACI,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AANZ;AAUI;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AARR;AAUQ;EACI,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AARZ;AAUY;EACI,iCAAA;AARhB;AAYQ;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAVZ;AAYY;EACI,yBAAA;AAVhB","sourcesContent":[".login-form__error {\n    color: #ff0000;\n    font-size: 0.875rem;\n    text-align: center;\n    width: 100%;\n    display: block;\n}\n\n.login-form__success {\n    color: #22c55e;\n    font-size: 0.875rem;\n    text-align: center;\n    width: 100%;\n    display: block;\n}\n\n.login-form__inputs__button {\n    transition: none !important;\n    \n    .p-button-label,\n    .p-button-icon {\n        transition: none !important;\n    }\n}\n\n.mask {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: fixed;\n    z-index: 101;\n}\n.login-form{\n.confirmation-popup {\n    visibility: hidden;\n    position: fixed;\n    display: flex;\n    width: auto;\n    min-width: 30rem;\n    max-width: 35rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    flex-direction: column;\n    background-color: white;\n    z-index: 1;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);\n    border-radius: 1rem;\n    padding: 1rem;\n    gap: 1rem;\n\n    &.visible {\n        visibility: visible !important;\n        opacity: 1;\n        transition: visibility 0s, opacity 0.5s linear;\n    }\n\n    &__header {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        border-bottom: 1px solid #DEDEDE;\n        padding-bottom: 15px;\n        position: relative;\n\n        &__titles {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            flex-direction: column;\n            gap: 0.4rem;\n            width: 100%;\n            padding: 0 40px;\n\n            &__title {\n                font-size: 1.5rem;\n                font-weight: bold;\n                text-align: center;\n                color: black;\n                white-space: nowrap;\n                overflow: visible;\n            }\n        }\n\n        &__close-button {\n            position: absolute;\n            right: 0;\n            top: 0;\n            width: 40px;\n            height: 40px;\n            background-color: white;\n            color: black;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n        }\n    }\n\n    &__content {\n        display: flex;\n        flex-direction: column;\n        gap: 0.75rem;\n        margin-bottom: 1rem;\n\n        &__warning {\n            display: flex;\n            justify-content: center;\n            font-size: 0.85rem;\n            color: #7E7E7E;\n            white-space: nowrap;\n            overflow: visible;\n            text-wrap: wrap;\n            text-align: center;\n        }\n\n        &__title {\n            font-size: 0.9rem;\n            color: black;\n            font-weight: bold;\n            white-space: nowrap;\n            overflow: visible;\n        }\n    }\n\n    &__footer {\n        display: flex;\n        flex-direction: row;\n        justify-content: end;\n        gap: 0.5rem;\n\n        &__confirm-button.p-button {\n            width: fit-content;\n            height: 40px;\n            background-color: black !important;\n            color: white;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n\n            &:hover {\n                background-color: #333 !important;\n            }\n        }\n\n        &__cancel-button.p-button {\n            width: fit-content;\n            height: 40px;\n            background-color: #F5F6FA;\n            color: black;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n\n            &:hover {\n                background-color: #EAEBEF;\n            }\n        }\n    }\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
